import React, { useState, useEffect } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";

// Helper: get token from localStorage
const getToken = () =>
  localStorage.getItem("session_token") ||
  localStorage.getItem("token") ||
  null;

const AssignPage = () => {
  const { patient_id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const patient = location.state?.patient;

  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");
  const [assignedUserName, setAssignedUserName] = useState("");
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  // Fetch available users
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        setLoading(true);
        const token = getToken();
        const url =
          "https://newerp.awasthivitality.com/api/users/available" +
          (token ? `?token=${encodeURIComponent(token)}` : "");

        const response = await fetch(url);
        const data = await response.json();

        if (data.success && Array.isArray(data.data)) {
          setUsers(data.data);
          if (data.data.length > 0) {
            setSelectedUser(data.data[0].user_name);
          }
        } else {
          setError(data.msg || "Failed to load users");
        }
      } catch (error) {
        console.error("Error fetching users:", error);
        setError("Error loading users: " + error.message);
        setUsers([]);
      } finally {
        setLoading(false);
      }
    };
    fetchUsers();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    if (!selectedUser) {
      setError("⚠️ Please select a user");
      return;
    }

    setSubmitting(true);
    try {
      const token = getToken();
      const url =
        `https://newerp.awasthivitality.com/api/patient/assign/${patient_id}` +
        (token ? `?token=${encodeURIComponent(token)}` : "");

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(token && { Authorization: `Bearer ${token}` })
        },
        body: JSON.stringify({ patient_assign: selectedUser })
      });

      const result = await response.json();

      if (result.success) {
        setAssignedUserName(result.assigned_to || selectedUser);
        alert(`✅ ${result.msg || "Patient assigned successfully"}`);
        
        // Redirect to patient list after short delay
        setTimeout(() => {
          navigate("/PatientList");
        }, 1000);
      } else {
        const errorMsg = result.msg || result.message || "Assignment failed";
        setError(`❌ ${errorMsg}`);
        alert(`❌ ${errorMsg}`);
      }

    } catch (error) {
      console.error("Error assigning patient:", error);
      const errorMsg = "Something went wrong while assigning: " + error.message;
      setError(errorMsg);
      alert(errorMsg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        padding: "40px",
        background: "linear-gradient(135deg, #e0f7fa, #fce4ec)",
        minHeight: "100vh",
      }}
    >
      <div
        style={{
          backgroundColor: "#fff",
          padding: "30px",
          borderRadius: "16px",
          boxShadow: "0px 6px 25px rgba(0,0,0,0.15)",
          width: "500px",
          maxWidth: "90%",
        }}
      >
        <h2
          style={{
            marginBottom: "15px",
            textAlign: "center",
            color: "#2c3e50",
          }}
        >
          Assign Patient
        </h2>

        {assignedUserName && (
          <p
            style={{
              textAlign: "center",
              fontWeight: "bold",
              color: "#28a745",
              fontSize: "16px",
              marginBottom: "15px",
            }}
          >
            Assigned to: {assignedUserName}
          </p>
        )}

        {error && (
          <p
            style={{
              textAlign: "center",
              color: "#dc3545",
              fontSize: "14px",
              marginBottom: "15px",
              padding: "10px",
              backgroundColor: "#f8d7da",
              borderRadius: "5px",
            }}
          >
            {error}
          </p>
        )}

        <p style={{ marginBottom: "25px", textAlign: "center", fontSize: "16px" }}>
          <strong>Patient:</strong> {patient?.name || `ID: ${patient_id}`}
        </p>

        {loading ? (
          <p style={{ textAlign: "center" }}>Loading users...</p>
        ) : users.length === 0 ? (
          <p style={{ color: "red", textAlign: "center" }}>
            No users found! {error && `(${error})`}
          </p>
        ) : (
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: "20px" }}>
              <label
                style={{
                  fontWeight: "bold",
                  display: "block",
                  marginBottom: "8px",
                }}
              >
                Select User
              </label>
              <select
                value={selectedUser}
                onChange={(e) => setSelectedUser(e.target.value)}
                disabled={submitting}
                style={{
                  width: "100%",
                  padding: "12px",
                  borderRadius: "8px",
                  border: "1px solid #ccc",
                  fontSize: "16px",
                  background: submitting ? "#f5f5f5" : "#f9f9f9",
                  cursor: submitting ? "not-allowed" : "pointer",
                }}
              >
                {users.map((user) => (
                  <option key={user.user_name} value={user.user_name}>
                    {user.user_name}
                  </option>
                ))}
              </select>
            </div>

            <button
              type="submit"
              disabled={submitting || !selectedUser}
              style={{
                width: "100%",
                backgroundColor: submitting || !selectedUser ? "#aaa" : "#28a745",
                color: "white",
                padding: "14px",
                fontSize: "16px",
                fontWeight: "bold",
                border: "none",
                borderRadius: "10px",
                cursor: submitting || !selectedUser ? "not-allowed" : "pointer",
                transition: "0.3s",
              }}
            >
              {submitting ? "Assigning..." : "Assign"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default AssignPage;